import Vue from 'vue';
import VueLodash from 'vue-lodash';
import { get, replace, startCase, lowerCase } from 'lodash';

// name is optional
Vue.use(VueLodash, {
  name: 'custom',
  lodash: { get, replace, startCase, lowerCase }
});
